import { RolesEnum } from '@/items/Roles';
import { Model } from '@/models/Model';
import store from '@/store';
import { Token } from '@/support/Token';
export const currentUserIncludes = ['roles'];
export class User extends Model {
    constructor() {
        super(...arguments);
        this.age = 0;
        this.$name = 'User';
        this.$endpoint = '/users';
        this.$fillable = ['name', 'email', 'password', 'password_previous', 'note', 'parnassys_id'];
    }
    current() {
        return this.filter('current', true)
            .include(currentUserIncludes)
            .first();
    }
    isAuthenticated() {
        if (!Token.get()) {
            return false;
        }
        this.token = Token.get();
        return Token.get().length > 0;
    }
    hasValidMfa() {
        return !this.mfa_required || !!this.has_mfa_token;
    }
    static currentAuth() {
        return store.state.Auth;
    }
    logout() {
        this.token = undefined;
        Token.delete();
    }
    hasRole(roles) {
        if (!this.roles) {
            return false;
        }
        if (typeof roles === 'string') {
            roles = [roles];
        }
        return this.roles.some((role) => roles.includes(role.id));
    }
    async restoreUser() {
        return await this.request('get', `${this.$endpoint}/restore?user=${this.id}`);
    }
    async downloadReport() {
        return await this.request('get', `${this.$endpoint}/${this.id}/download-report`);
    }
    async listBookmarks() {
        const url = `${this.$endpoint}/${this.id}/relationships/bookmarks`;
        return this.request('get', url, {});
    }
    async updateSubjectMass() {
        const url = `${this.$endpoint}/${this.id}/relationships/subjects/mass`;
        return this.request('patch', url, {});
    }
    setSubjectMassEndpoint() {
        this.$endpoint = `${this.$endpoint}/${this.id}/relationships/subjects/mass`;
        return this;
    }
    async deleteBookmark(bookmarkId) {
        const url = `${this.$endpoint}/${this.id}/relationships/bookmarks/${bookmarkId}`;
        return this.request('delete', url, {});
    }
    createBookmark(payload) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/relationships/bookmarks`;
        return this.request('post', url, payload);
    }
    updateBookmark(bookmarkId, payload) {
        const url = `${this.$endpoint}/${this.resolvePrimaryKey()}/relationships/bookmarks/${bookmarkId}`;
        return this.request('patch', url, payload);
    }
    get rolesLabel() {
        if (!this.roles) {
            return '';
        }
        return this.roles
            .map((role) => role.name)
            .join(', ')
            .replace(/, ([^,]*)$/, ' and $1');
    }
    get isGuardian() {
        if (!this.roles) {
            return false;
        }
        return this.roles.find((role) => role.id === RolesEnum.GUARDIAN) ? true : false;
    }
    get isStudent() {
        if (!this.roles) {
            return false;
        }
        return this.roles.find((role) => role.id === RolesEnum.STUDENT) ? true : false;
    }
    get isGlobalUser() {
        return !!(this.global_id);
    }
    get isTeacher() {
        if (!this.roles) {
            return false;
        }
        return this.roles.find((role) => role.id === RolesEnum.TEACHER) ? true : false;
    }
    static async attemptLogin() {
        // console.log('[USER] attemptLogin');
        let user = this.currentAuth();
        if (Token.get() && !user) {
            user = await new User()
                .current()
                .catch((error) => {
                const errorStatus = error.response
                    && error.response.status
                    ? error.response.status
                    : undefined;
                const errorMessage = error
                    && error.response
                    && error.response.data
                    && error.response.data.message
                    ? error.response.data.message
                    : undefined;
                // console.log('[USER] errorStatus', errorStatus, 'errorMessage', errorMessage);
                // console.log('[USER] userDeauthenticated');
                Token.delete();
                store.dispatch('userDeauthenticated', user);
            });
            if (user) {
                // console.log('[USER] userAuthenticated');
                store.dispatch('userAuthenticated', user);
            }
        }
        return user;
    }
}
export const userReportGoals = ['1F', '2F', '1S'];
